import { render, staticRenderFns } from "./ParamTipoServico.vue?vue&type=template&id=5ca0bbe9&scoped=true"
import script from "./ParamTipoServico.vue?vue&type=script&lang=js"
export * from "./ParamTipoServico.vue?vue&type=script&lang=js"
import style0 from "./ParamTipoServico.vue?vue&type=style&index=0&id=5ca0bbe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0bbe9",
  null
  
)

export default component.exports